import styles from './index.module.scss'
import { Typography } from "@stardust-ds/react";

export default function CircleGraphic(props) {
    const { nCurrent, nTotal, children } = props;

    const nPercentage = (nCurrent * 100) / nTotal;

    let cPercentageColor = '#6CB6E3';
    if (nCurrent > (nTotal * 0.95)) {
        cPercentageColor = '#FF0000';
    }

    const cBackgroundImage = `conic-gradient(${cPercentageColor} ${nPercentage}%, #FFFFFF ${nPercentage - nTotal}%)`

    return (
        <div className={styles.graphicContainer}>
            <div className={styles.graphic} style={{ backgroundImage: cBackgroundImage }} />
            <Typography type='l4' fontSize="xxxs" className={styles.range}>{children}</Typography>
        </div>
    )
}